import Navbar from "../components/navbar";
import PackageSubscribe from "../components/PackagePage/package-subscribe";


const Package = () => {
    return (
      <>
        <Navbar />
        <PackageSubscribe/>
      </>
    );
  };
  
  export default Package;